import React, { useContext, useEffect, useState } from "react";

import { ModalContext } from "../../context/ModalContext";
import StandardPopup from "../standardPopup/StandardPopup";
import { useAppContext } from "../../context/AppContext";

const RegularNewsletter = () => {
  const { handleModal } = useContext(ModalContext);
  const { popupData } = useAppContext();
  const [open, setOpen] = useState(false);

  const data = popupData.find((item) => item.popupName === "regularNewsletter");

  useEffect(() => {
    !open
      ? handleModal({
          content: <StandardPopup popupContent={data} newsletterList />,
          withImage: true,
          // fullScreen: true,
        })
      : null;
    setOpen(true);
  }, [handleModal, open, data]);

  return <></>;
};

export default RegularNewsletter;
